<template>
  <div style="padding-top: 1rem;background:#fff">
    <!--<navTitle title="个人资料"></navTitle>-->
    <navTitle
      :title="
        $router.app._route.query.ti ? $router.app._route.query.ti : 'User profile'
      "
      path="/user"
    ></navTitle>

    <div class="paycontent">
     <div class="paytop">
         <div class="payrow">
             <img class="logo" src="../../assets/images/pay_logo5.png" alt="">
         </div>
         <!-- 金额 -->
          <div class="payrow">
            <div class="payinput">
                <div class="paytext-icon">IDR</div>
                <div class="paytext">{{pay_money | MoneyFormat}}</div>
            </div>
         </div>
         <div class="payrow" style=" text-align:left">Please insert your <b>mobile number</b> as your DANA ID</div>
         <div class="payhr"></div>
         <div class="payrow">
            <div class="payinput">
                <div class="payinput-icon">payer</div>
                <input class="payinput-dom" v-model="q.payer" placeholder="please enter your real name" type="text" name="name" id=""> 
            </div>
         </div>
         <div class="payrow">
            <div class="payinput">
                <div class="payinput-icon">62</div>
                <input class="payinput-dom" v-model="q.phone"   placeholder="please enter your mobile number" type="text" name="phone" id=""> 
            </div>
         </div>
         <div class="payrow">
            <div class="payinput">
                <div class="payinput-icon">email</div>
                <input class="payinput-dom"  v-model="q.email"    placeholder="please enter your email" type="text" name="email" id=""> 
            </div>
         </div>
         <div class="payrow">
            <div class="payinput">
                <div class="payinput-icon">channel</div>
                <select   class="payinput-dom"   v-model="q.channel"   name="channel" id="">
                    <option value="">Please select service channel</option>

                    <option value ="CIMBVA">CIMBVA</option>
                    <option value ="BNIVA">BNIVA</option>
                    <option value="MandiriVA">MandiriVA</option>
                    <option value="PermataVA">PermataVA</option>
                    <option value="MaybankVA">MaybankVA</option>
                    <option value="ConvenienceStore">ConvenienceStore</option>
                    <option value="INDOStore">INDOStore</option>
                    <option value="DANAWALLET">DANAWALLET</option>
                    <option value="OVOWALLET">OVOWALLET</option>
                    <option value="AKULAKUWALLET">AKULAKUWALLET</option>
                </select>
            </div>
         </div>
     </div>
     <div class="btn" @click="wayangpay_create">submit</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { trim, VUE_APP_API_URL, isWeixin } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";
import { postUserEdit, getLogout, switchH5Login, getUser,wayangpay_create } from "@api/user";
import { clearAuthStatus } from "@libs/wechat";
import navTitle from "@components/navTitle.vue";
import cookie from "@utils/store/cookie";
import store from "@/store";
import dayjs from "dayjs";

export default {
  name: "ovopay",
  components: {
    VueCoreImageUpload,
    navTitle
  },
  data: function() {
    return {
      pay_money:0,
      q:{
        phone:'',
        email:'',
        channel:'',
        money:'',
        payer:'',
      }
    };
  },
  watch: {
    $route(n) {
      if (n.name === "ovopay") {
       

      }
    }
  },
  computed: mapGetters(["userInfo"]),
  mounted: function() {
     this.pay_money = this.$route.query.m || 5000
     this.q.money = this.$route.query.m || 5000
    
  },
  methods: {
    getUserInfo: function() {
      let that = this;
      getUser().then(res => {
        let switchUserInfo = res.data.switchUserInfo;
        for (let i = 0; i < switchUserInfo.length; i++) {
          if (switchUserInfo[i].uid == that.userInfo.uid) that.userIndex = i;
          if (
            !that.isWeixin &&
            switchUserInfo[i].user_type != "h5" &&
            switchUserInfo[i].phone === ""
          )
            switchUserInfo.splice(i, 1);
        }
        that.$set(this, "switchUserInfo", switchUserInfo);
      });
      
    },
    wayangpay_create(){
      let q =this.q
        if(!q.phone && !q.email && !q.channel && !q.money &&!q.payer){
          return this.$dialog.error('Lack of necessary information')
        }
        wayangpay_create(q).then(res=>{
          console.log('create===>',res)
        })
      }
  }
};
</script>

<style  scoped>
.paycontent {
  width: 100%;
  background: #fff;
  position:fixed;
  width: 100%;
  height: calc( 100% - 1rem);
  top: 1rem;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 0 0.28rem;
  box-sizing: border-box;
}
.payrow{
    width: 100%;
    height: 1rem;
    text-align: center;
    font-size: 0.34rem;
    
}
.payhr{
    width: 100%;
    height: 0.4rem;
    padding-bottom: 0.8rem;
    border-bottom: 1px solid #eee;
}
.logo{
    /* width: 2.2rem; */
    /* width: 2rem; */
}
.payinput{
    width: 100%;
    height: 0.8rem;
    line-height: 0.8rem;
    display: flex;
    margin-top: 0.5rem;
    justify-content: space-between;
}
.payinput-icon{
    width:1.5rem;
    height: 0.8rem;
    line-height: 0.8rem;
    border: 1 px solid #eee;
    border-radius: 50%;
}
.payinput-dom{
    flex: 1;
    height: 0.8rem;
    line-height: 0.8rem;
    border-bottom: 2px solid #eee;
  transition: all 0.3s;

}
.paytext-icon{
    width: 1.2rem;
    height: 0.8rem;
    line-height: 0.8rem;
    border: 1 px solid #eee;
    border-radius: 50%;
  font-size: 0.46rem;
  font-weight: bold;
  text-align: left;
}
.paytext{
   flex: 1;
    height: 0.8rem;
    line-height: 0.8rem;
    /* border-bottom: 2px solid #eee; */
  transition: all 0.3s;
  font-size: 0.46rem;
  font-weight: bold;
  text-align: left;

}
.payinput-dom:focus{
  border-bottom: 2px solid #45C3F9;
  transition: all 0.3s;
}
.btn{
  width: 90%;
  height: 1rem;
  line-height: 1rem;
  color: #fff;
  background: #45C3F9;
  text-align: center;
  border-radius: 7px;
  font-size: 0.36rem;
  margin: 0 auto;
  position: absolute;
  bottom: 28px;
  transition: all 0.3s;

}
.btn:active{
  background: rgb(33, 129, 231);
  transition: all 0.3s;

}

</style>
